import {useGeneralProvider} from 'brandComponents/_app-config/GeneralProvider';
import {useLocation} from 'coreHooks';
import {PageType} from 'coreUtils/IUtils';

const useCurrentPageType = () => {
	const {managerRepository} = useGeneralProvider();
	const location = useLocation();

	switch (true) {
		case location.pageType === PageType.HP && location.isHomePage:
			return PageType.HP;
		case location.pageType === PageType.PLP:
			return PageType.PLP;
		case location.pageType === PageType.PDP:
			return PageType.PDP;
		default:
			return managerRepository.getLocalesMgr()
				.getUrlWithoutLocale(location.pathname)
				.replace(/[/]/g, '')
				.replace(/[-]/g, '_')
				.toUpperCase() as PageType;
	}
};

export default useCurrentPageType;